import React, { FC } from 'react';
import { Box, BoxProps, Tooltip, TooltipProps, IconButton } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { WarningIcon } from '@chakra-ui/icons';
import { rem } from 'utils/fonts';

interface Props {
  message: string | undefined;
  placement?: TooltipProps['placement'];
  tooltipZIndex?: number;
}

const StyledBox = styled(Box)`
  position: relative;
`;

const StyledTooltip = styled(Tooltip)`
  border-radius: 6px;
  padding: 5px 20px;
  font-size: ${rem(12)};
`;

const StyledIconButton = styled(IconButton)`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  padding: 0;
  min-width: auto;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const ErrorMessage: FC<BoxProps & Props> = ({ message, placement = 'right', tooltipZIndex = 9, ...props }) => (
  <StyledBox {...props} zIndex={tooltipZIndex}>
    {message && (
      <StyledTooltip bg="pink.500" label={message} placement={placement} zIndex={tooltipZIndex} aria-label="input has error" closeOnClick>
        <StyledIconButton icon={<WarningIcon />} color="pink.500" bg="white" aria-label="error message" />
      </StyledTooltip>
    )}
  </StyledBox>
);

export default ErrorMessage;
